// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const PortalFacebookSquare = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 96 96" {...props}>
		<path
			d="M87.5 16.964v62.072a8.466 8.466 0 0 1-8.464 8.464H63.994V56.253H74.68l1.534-11.92h-12.22v-7.619c0-3.456.952-5.801 5.907-5.801h6.313V20.262c-1.093-.141-4.831-.476-9.205-.476-9.099 0-15.341 5.554-15.341 15.764v8.8H40.946v11.92h10.74V87.5H16.963A8.466 8.466 0 0 1 8.5 79.036V16.964A8.466 8.466 0 0 1 16.964 8.5h62.072a8.466 8.466 0 0 1 8.464 8.464Z"
			fill="currentColor"
			fillRule="evenodd"
		/>
	</svg>
);
export default PortalFacebookSquare;
